<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Edit Attachment"
    icon="edit"
    :toolbarActions="[
      {
        text: 'Save',
        icon: 'save',
        buttonColor: 'success',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
        isDisabledFunc: () => !isFormValid,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
    :isLoading="isLoading"
  >
    <v-container pa-0 grid-list-lg>
      <v-form v-model="isFormValid" ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <ControlTextArea
              v-model="comments"
              label="Comments"
              :disabled="isLoading"
            />
          </v-flex>
        </v-layout>
        <small>*indicates required field</small>
      </v-form>
    </v-container>
  </DialogContainer>
</template>

<script>
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'

import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlTextField from '../../../common/components/controls/ControlTextField'
import ControlAutoComplete from '../../../common/components/controls/ControlAutoComplete'
import ControlTextArea from '../../../common/components/controls/ControlTextArea'

export default {
  components: {
    DialogContainer,
    ControlTextField,
    ControlAutoComplete,
    ControlTextArea,
  },
  mixins: [mixinAssetHelper],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    attachmentToEdit: {
      type: Object,
      required: false,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFormValid: false,
    comments: null,
  }),
  computed: {},
  watch: {
    showDialog() {
      if (
        this.showDialog &&
        this.attachmentToEdit &&
        this.attachmentToEdit.id
      ) {
        this.comments = this.attachmentToEdit.comments
      }
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        comments: this.comments,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.comments = null
    },
  },
}
</script>